import React from 'react';
import { SvgIconProps } from '@mui/material';

export const EditIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.4999 24.1667H24.7708M21.7499 12.0833L25.3749 8.45833L20.5416 3.625L16.9166 7.25M21.7499 12.0833L9.66658 24.1667H4.83325V19.3333L16.9166 7.25M21.7499 12.0833L16.9166 7.25"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default EditIcon;
